import { ReactElement } from 'react';
import { baseClass } from './CreateAccount';
import { InputGroupProps } from './InputField';
import { FormFeedback, FormGroup } from '../../components';

export const EmailFields = ({ register, errors }: InputGroupProps): ReactElement => {
  return (
    <>
      <FormGroup className={`${baseClass}__form-group`}>
        <label htmlFor="email">
          <span className={`${baseClass}__label`}>Email</span>
          <input
            {...register('email')}
            className={`${baseClass}__input vol-input`}
            name="email"
            data-testid="emailInput"
          />
        </label>
        <FormFeedback className={`${baseClass}__feedback`}>{errors?.email?.message}</FormFeedback>
      </FormGroup>
      <FormGroup className={`${baseClass}__form-group`}>
        <label htmlFor="confirmEmail">
          <span className={`${baseClass}__label`}>Confirm Email</span>
          <input
            {...register('confirmEmail')}
            className={`${baseClass}__input vol-input`}
            name="confirmEmail"
            data-testid="confirmEmailInput"
          />
        </label>

        <FormFeedback className={`${baseClass}__feedback`}>
          {errors?.confirmEmail?.message}
        </FormFeedback>
      </FormGroup>
    </>
  );
};

export default EmailFields;
